import { StringOrComponent } from '../../models';
import DataTable from './DataTable';

export interface ReportLabels {
  itemCount?: StringOrComponent;
  perPage?: string;
  showing?: string;
  searchPlaceHolder?: string;
}

export { DataTable };
